
import { computed, defineComponent, onMounted, ref } from 'vue';
import ServiceItem from 'PortalDir/modules/Services/components/Item.vue';
import { usePublicServicesList } from 'PortalDir/modules/Services/composables/usePublicServicesList';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { useAppStore } from 'stores/app';
import { useLoadingSsr } from 'PortalDir/common/composables/useLoadingSsr';
import ServiceSkeletonItem from 'SharedDir/modules/Services/components/skeletons/SkeletonItem.vue';
import { random } from '@packages/toolbox';

export default defineComponent({
  name: 'ServiceList',
  methods: { random },
  components: { ServiceSkeletonItem, ServiceItem },

  setup() {
    const appStore = useAppStore();
    const serviceList = computed(() => {
      return appStore.serviceList;
    });

    const { isMobile } = useDeviceSize();
    const { isLoading, showLoading } = useLoadingSsr();

    const serviceRouteName: string = 'services';
    const slide = ref(0);

    const { getShortServiceList, list } = usePublicServicesList();

    function isMainGrid(index) {
      if (index === 3 || index === 4) {
        return true;
      }
      return false;
    }

    onMounted(async () => {
      isLoading.value = false;
    });

    return { serviceRouteName, isMobile, slide, serviceList, isMainGrid, isLoading };
  },
});
